import "../../stylesheets/navbar.css";
import { NavLink } from "./NavbarElements";

export default function Navbar() {
  return (
    <nav className="Navbar">
      <NavLink name="Home" target="/" />
      <NavLink name="Projects" target="/projects" />
      <NavLink name="Blog" target="/under-construction" />
      <NavLink name="BarDown" target="/under-construction" />
      <NavLink name="Contact Me" target="/contact" />
    </nav>
  );
}
